import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "more-menu"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "cursor" }, "合并客服组", -1)
const _hoisted_3 = { class: "drop-item-menu" }
const _hoisted_4 = { class: "out-line-btn" }
const _hoisted_5 = {
  key: 1,
  class: "more-menu"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "cursor" }, "移入一个客户组", -1)
const _hoisted_7 = { class: "drop-item-menu" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", { class: "item" }, "合并客户", -1)
const _hoisted_9 = { class: "out-line-btn" }
const _hoisted_10 = {
  key: 2,
  class: "more-menu"
}
const _hoisted_11 = { class: "drop-item-menu" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("p", { class: "item" }, "合并客户", -1)
const _hoisted_13 = { class: "out-line-btn" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", null, "合并后将把上述客户请求记录（工单、会话、通话）全部转移至目标客户并删除其余客户，删除后将无法恢复，请谨慎操作", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CaretDownOutlined = _resolveComponent("CaretDownOutlined")!
  const _component_Popover = _resolveComponent("Popover")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("span", {
      class: "cursor",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleCancelSelect && _ctx.handleCancelSelect(...args)))
    }, "取消选中"),
    (_ctx.viewObj.type === 'userGroup')
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _hoisted_2,
          _createVNode(_component_Popover, {
            overlayClassName: "menu-popover",
            trigger: "click",
            placement: "bottomRight"
          }, {
            content: _withCtx(() => [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("p", {
                  class: "item",
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleBatchDeleteGroup && _ctx.handleBatchDeleteGroup(...args)))
                }, "批量删除")
              ])
            ]),
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_CaretDownOutlined)
              ])
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true),
    (_ctx.viewObj.title === 'VIEW_TITLE_USER')
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _hoisted_6,
          _createVNode(_component_Popover, {
            overlayClassName: "menu-popover",
            trigger: "click",
            placement: "bottomRight"
          }, {
            content: _withCtx(() => [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("p", {
                  class: "item",
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleBatchDeleteGroup && _ctx.handleBatchDeleteGroup(...args)))
                }, "移入一个客户组"),
                _hoisted_8,
                _createElementVNode("p", {
                  class: "item",
                  onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.handleAddblackList && _ctx.handleAddblackList(...args)))
                }, "加入黑名单"),
                _createElementVNode("p", {
                  class: "item",
                  onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.handleDeleteUser && _ctx.handleDeleteUser(...args)))
                }, "删除")
              ])
            ]),
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_9, [
                _createVNode(_component_CaretDownOutlined)
              ])
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true),
    (_ctx.viewObj.title === 'VIEW_TITLE_USER_BLACKLIST')
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _createElementVNode("span", {
            class: "cursor",
            onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.handleMoveUserfromBlacklist && _ctx.handleMoveUserfromBlacklist(...args)))
          }, "移除黑名单"),
          _createVNode(_component_Popover, {
            overlayClassName: "menu-popover",
            trigger: "click",
            placement: "bottomRight"
          }, {
            content: _withCtx(() => [
              _createElementVNode("div", _hoisted_11, [
                _hoisted_12,
                _createElementVNode("p", {
                  class: "item",
                  onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.handleMoveUserfromBlacklist && _ctx.handleMoveUserfromBlacklist(...args)))
                }, "移除黑名单"),
                _createElementVNode("p", {
                  class: "item",
                  onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.handleDeleteUser && _ctx.handleDeleteUser(...args)))
                }, "删除")
              ])
            ]),
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_13, [
                _createVNode(_component_CaretDownOutlined)
              ])
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_Modal, {
      visible: false,
      title: "请选择合并到哪一个客户",
      "cancel-text": "取消",
      "ok-text": "下一步"
    }, {
      default: _withCtx(() => [
        _hoisted_14
      ]),
      _: 1
    })
  ], 64))
}